<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Maestro" class="d-icon d-icon--maestro" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x=".25" y="3.75" width="23.5" height="16.5" rx="1.75" fill="#fff" stroke="#E3E5E8" stroke-width=".5"/><path d="M13.358 11.733c0 2.615-2.095 4.734-4.679 4.734S4 14.347 4 11.734C4 9.118 6.095 7 8.68 7c2.583 0 4.678 2.12 4.678 4.733Z" fill="#ED0006"/><path d="M19.429 11.733c0 2.615-2.095 4.734-4.68 4.734-2.584 0-4.679-2.12-4.679-4.733C10.07 9.118 12.165 7 14.75 7c2.584 0 4.679 2.12 4.679 4.733Z" fill="#0099DF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.714 8.13a4.745 4.745 0 0 1 1.644 3.603 4.745 4.745 0 0 1-1.644 3.603 4.745 4.745 0 0 1-1.644-3.603c0-1.442.638-2.734 1.644-3.602Z" fill="#6C6BBD"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMaestro',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
